import {SettingItemUser} from "../backend/backendapi";

export function filterSettingsByPrefix(
    items: SettingItemUser[],
    prefix: string
): SettingItemUser[] {
    if (!prefix) return [...items]; // no prefix => return all

    const normalizedPrefix = prefix.toLowerCase();

    return items.filter(item =>
        (item.key ?? "").toLowerCase().startsWith(normalizedPrefix)
    );
}